"use client"

import { Button, Text } from "@/elements"
import React, { FC } from "react"
import { ControlledModal } from "../Dialog"
import { ProLockIcon } from "@/icons/outline/ProLockIcon"

interface Props {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onClickGoPro: () => void
  creativeFirstName: string
}

const RightElement = () => <ProLockIcon />

export const ContactInfoUpsellModal: FC<Props> = ({ isOpen, creativeFirstName, onOpenChange, onClickGoPro }) => {
  return (
    <ControlledModal
      open={isOpen}
      onClose={() => onOpenChange(false)}
      fullScreenOnMobile={false}
      closeIconButtonVariant="transparent-white"
      contentClassName="bg-pro-gradient-100  px-0 pb-0"
      onOpenChange={onOpenChange}
      body={
        <div className="flex flex-col items-center justify-center">
          <img
            alt="Pro Contact Modal Image"
            src="https://d201dxmsht1mhv.cloudfront.net/pro-contact-modal-image.png"
            className="absolute left-0 right-0 top-0"
          />
          <Text variant="h5" className="mt-6 w-[320px] pt-[220px] text-center">
            Sign up for Pro to view {creativeFirstName}’s contact information
          </Text>
          <Button
            onClick={onClickGoPro}
            className="mt-8 w-[256px]"
            variant="primary"
            size="large"
            RightElement={RightElement}>
            Unlock Pro
          </Button>
        </div>
      }
    />
  )
}
